import React from 'react';
import { InvitationStatus } from '@lnr-v2/types';
import { Badge } from '../../atoms/Badge';
import styles from './InvitationStatusBadge.module.css';

interface InvitationStatusBadgeProps {
  status: InvitationStatus;
  expiresAt?: string;
}

/**
 * Displays a color-coded badge for invitation status
 */
export const InvitationStatusBadge: React.FC<InvitationStatusBadgeProps> = ({
  status,
  expiresAt,
}) => {
  const getStatusColor = (): 'warning' | 'success' | 'error' | 'default' => {
    switch (status) {
      case InvitationStatus.PENDING:
        // Check if expired
        if (expiresAt && new Date(expiresAt) < new Date()) {
          return 'error';
        }
        return 'warning';
      case InvitationStatus.ACCEPTED:
        return 'success';
      case InvitationStatus.EXPIRED:
        return 'error';
      case InvitationStatus.REVOKED:
        return 'default';
      default:
        return 'default';
    }
  };

  const getStatusText = (): string => {
    if (status === InvitationStatus.PENDING) {
      if (expiresAt && new Date(expiresAt) < new Date()) {
        return 'Expired';
      }
      return 'Pending';
    }
    return status.charAt(0) + status.slice(1).toLowerCase();
  };

  return (
    <Badge variant={getStatusColor()} className={styles.badge}>
      {getStatusText()}
    </Badge>
  );
};
